import { useState, useEffect } from "react";
import axiosInstance from "../services/axiosComman";

const UseGetInsideData = ({ page = "", pageCount = "", url, search = "" }) => {
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setLoading] = useState(true);

  async function getData() {
    setLoading(true);
    let params = {
      page: page,
      per_page: pageCount,
    };

    if (search !== "") {
      params.search = search;
    }

    try {
      const res = await axiosInstance.get(url, { params });
      if (res.data) {
        setData(res?.data);
        setTotalCount(res?.data?.total_record || res?.data?.total || 0);
      } else {
        console.log(res.data?.msg || res.data?.error);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, [url, page, pageCount, search]);

  return { data, totalCount, getData, isLoading };
};

export default UseGetInsideData;
